import * as ApiManager from './_manager';
import store from '@/store';

export const filmMaker = {
  get: (payload = null) => {
    return ApiManager.callApi (
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/filmMaker/get`,
      payload
    );
  },
};
